/**
 * Copyright 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { TableSearchInput } from "~/components/SearchInput";
import { useQueryState } from "~/hooks/useQueryState/useQueryState";
import { ResourceQuery } from "~/views/resources/types";

export function ResourceSearch() {
  const { queryState, updateQueryState } = useQueryState<ResourceQuery>();

  const handlePhraseField = (field: string | undefined) => {
    updateQueryState({
      ...queryState,
      searchPhrase: field,
    });
  };

  return (
    <TableSearchInput<ResourceQuery>
      onSubmit={handlePhraseField}
      placeholder={
        "Type a Keyword (e.g. Resource Name, Resource ID, Metadata, Tag, etc.)"
      }
    />
  );
}
